import React, { ComponentPropsWithoutRef } from 'react';
import '@rbx/ui';
import { resolveStaticSrc } from '../utils/staticLinkUtils';
import { useMarkdown } from './MarkdownProvider';

import useMarkdownVideoStyles from './MarkdownVideo.styles';

type MarkdownVideoProps = ComponentPropsWithoutRef<'video'>;

export default function MarkdownVideo({
  src,
  className,
  width,
  ...otherProps
}: MarkdownVideoProps) {
  const resolvedSrc = resolveStaticSrc(src);
  const { widths } = useMarkdown();
  const {
    classes: { video },

    cx,
  } = useMarkdownVideoStyles();

  return (
    // TODO: CRK-374 - replace this with Video component from @rbx/ui
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      width={width ?? widths?.video}
      {...otherProps}
      src={resolvedSrc}
      className={cx(video, className)}
    />
  );
}
